export const ZENDESK = 'https://memrisebeta.zendesk.com/hc';
export const ZENDESK_WEB_MICROPHONE_ARTICLE =
  'https://memrisebeta.zendesk.com/hc/articles/13327335997329';
export const ZENDESK_MOBILE_MICROPHONE_ARTICLE =
  'https://memrisebeta.zendesk.com/hc/articles/13327869078161';
export const SURVEY_MONKEY_FEEDBACK_LINK =
  'https://www.surveymonkey.com/r/JMSB3B9?language_pair_id=%5Blanguage_pair_id_value%5D&last_language_learnt=%5Blast_language_learnt_value%5D&is_premium=%5Bis_premium_value%5D';
